import { v4 as uuidv4 } from 'uuid';

export function uuid() {
  return uuidv4();
}
